var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { MEDIA_QUERIES } from 'shared/style';
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: auto;\n  ", " {\n    padding: 20px;\n  }\n  ", " {\n    padding: 20px 0;\n  }\n  text-align: center;\n\n  > .image {\n    > img {\n      max-width: 100%;\n    }\n  }\n\n  > .desc {\n    margin: 10px 0;\n    font-size: 14px;\n    color: #444;\n  }\n"], ["\n  width: 100%;\n  height: auto;\n  ", " {\n    padding: 20px;\n  }\n  ", " {\n    padding: 20px 0;\n  }\n  text-align: center;\n\n  > .image {\n    > img {\n      max-width: 100%;\n    }\n  }\n\n  > .desc {\n    margin: 10px 0;\n    font-size: 14px;\n    color: #444;\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
export default (function (_a) {
    var image = _a.image;
    var url = image.url, description = image.description;
    return (React.createElement(RootDiv, null,
        React.createElement("div", { className: "image" },
            React.createElement("img", { src: url })),
        description && (React.createElement("div", { className: "desc" }, description))));
});
var templateObject_1;
